import { render, staticRenderFns } from "./devolucoes.vue?vue&type=template&id=2978092b&scoped=true&"
import script from "./devolucoes.vue?vue&type=script&lang=js&"
export * from "./devolucoes.vue?vue&type=script&lang=js&"
import style0 from "./devolucoes.vue?vue&type=style&index=0&id=2978092b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2978092b",
  null
  
)

export default component.exports